import React, { Component } from 'react';

import { Label, Headline, Button } from '../../theme';
import { Slider, Slide } from '../../carousel';
import { Stove } from '../../svg';
import { isMobile } from '../../util';


class StoveProblem extends Component {
  render() {
    return (
      <div id="Plita" className="container__fluid">
        <div className="w__flex w__flex-row Justify-between w__flex-column__mobile">

          <div className="w__flex w__flex-column carousel Justify-between Align-center o-2__mobile Align-right__mobile">
            <Slider device="plita">

              <Slide
                text="O plita electrica, cu un arzator pornit, consuma in 10 ore aproximativ 23 kWh?"
              />

              <Slide
                text="Consumul specific pentru plitele electrice este cuprins intre 3500W si 6000W?"
              />

            </Slider>
            <Button enel >
              <span className="mobile__hidden">Vezi</span>  oferta enel
            </Button>
          </div>

          <div className="w__flex w__flex-column Align-right problem__content">
            {
              !isMobile && (
                <div className="chef">
                  <Stove.Chef />
                </div>
              )
            }
            <Label marginRight="4.16vw" background="#840050" >
              problema tatalui
            </Label>
            <Headline padding="4.16vw" large alignRight >
              <p style={{ color: '#840050', zIndex: 1 }}>FARA SA VREA<span className="punctuation">,</span></p>
              <p style={{ color: '#d33c64' }}>PLITA GATESTE</p>
              <p style={{ color: '#d33c64' }}>SI CAND NU</p>
              <p style={{ color: '#d33c64' }}>TREBUIE</p>
            </Headline>
            <div className="birds">
              <Stove.Birds isMobile={isMobile} />
            </div>
          </div>

        </div>
      </div>
    );
  }
}

export default StoveProblem;


// WEBPACK FOOTER //
// ./src/components/pages/Plita/StoveProblem.jsx